import {fromJS} from 'immutable';

import {getSession, logout} from '@albert-io/mandark/authentication';

import {Store} from 'client/framework';

import sessionLifecycleActions from './SessionLifecycleActions';

class SessionStore extends Store {
  constructor(name: string) {
    super(name);
    this.initialData = fromJS({
      hasSession: false
    });
    this.setInitialData(this.initialData);

    this.handle(sessionLifecycleActions.SET_SESSION_STATE, this.setSessionState);
    this.handle(sessionLifecycleActions.END_SESSION, this.handleLogout);
  }

  handleLogout() {
    const params = global.location.pathname.split('/');

    const inAssignment = params.some((param) => param === 'assignment');
    if (inAssignment && this.isStudent()) {
      if (global.window.confirm('Leaving this page may result in unsaved changes')) {
        logout();
      }
    } else {
      logout();
    }
  }

  setSessionState(hasSession: boolean) {
    this.writeData('hasSession', Boolean(hasSession));
  }

  hasValidSession() {
    return getSession().isValid();
  }

  // returns null for non-teachers
  getUserEmail() {
    return getSession().getEmail();
  }

  getLastAuthenticatedAt() {
    return getSession().getLastAuthenticatedAt();
  }

  getUserId() {
    return getSession().getId();
  }

  isStudent() {
    return getSession().isStudent();
  }

  isTeacher() {
    return getSession().isTeacher();
  }

  isSchoolAdministrator() {
    return getSession().isSchoolAdministrator();
  }

  isAuthor() {
    return getSession().isAuthor();
  }

  isContentManager() {
    return getSession().isContentManager();
  }

  isSuper() {
    return getSession().isSuper();
  }

  hasContentManagerAccess() {
    return getSession().hasContentManagerAccess();
  }

  hasAuthorAccess() {
    return getSession().hasAuthorAccess();
  }

  hasTeacherAccess() {
    return getSession().hasTeacherAccess();
  }

  isUserConfirmed() {
    return getSession().isConfirmed();
  }

  getAccountType() {
    return getSession().getAccountType();
  }

  getSignUpDate() {
    return getSession().getSignUpDate();
  }

  getDistrictCleverId() {
    return getSession().getDistrictCleverId();
  }
}

export default new SessionStore('SessionStore');
